import script from "./page-board.vue?vue&type=script&setup=true&lang=js"
export * from "./page-board.vue?vue&type=script&setup=true&lang=js"

import "./page-board.vue?vue&type=style&index=0&id=e340f8ec&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e340f8ec"]])

export default __exports__